import { createReducer } from '../utils/helpers';
import constants from '../constants';

const {
  FETCH_NATION_HORSES_REQUEST,
  FETCH_NATION_HORSES_SUCCESS,
  FETCH_NATION_HORSES_FAILURE,
  ADD_HORSE_REQUEST,
  ADD_HORSE_SUCCESS,
  ADD_HORSE_FAILURE,
} = constants;

const initialState = {
  nationHorses: [],
  isFetchingData: false,
};

export default createReducer(initialState, {
  [FETCH_NATION_HORSES_REQUEST]: state => ({
    ...state,
    ...{
      nationHorses: [],
      isFetchingData: true,
    },
  }),
  [FETCH_NATION_HORSES_SUCCESS]: (state, payload) => {
    const { horses } = payload;
    return {
      ...state,
      ...{
        nationHorses: horses,
        isFetchingData: false,
      },
    };
  },
  [FETCH_NATION_HORSES_FAILURE]: state => ({
    ...state,
    ...{
      nationHorses: [],
      isFetchingData: false,
    },
  }),
  [ADD_HORSE_SUCCESS]: (state, payload) => ({
    ...state,
    ...{
      isPushingData: false,
    },
  }),
  [ADD_HORSE_FAILURE]: state => ({
    ...state,
    ...{
      isPushingData: false,
    },
  }),
  [ADD_HORSE_REQUEST]: state => ({
    ...state,
    ...{
      isPushingData: true,
    },
  }),
});



// WEBPACK FOOTER //
// ./src/reducers/nationHorses.js